var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"blank-page"},[_c('div',{staticClass:"blank-img-box"},[_c('img',{attrs:{"src":_vm.blank.imgUrl}}),_c('span',[_vm._v(_vm._s(_vm.blank.text))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }